import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { appColors } from '../assets/appColors';
export var BackrsHeaderCard = function (_a) {
    var title = _a.title;
    return (_jsx(Box, { sx: headerCardStyle, children: _jsx(Typography, { variant: "h5", align: "center", fontWeight: 700, children: title }) }));
};
var headerCardStyle = {
    backgroundColor: appColors.color.blue1,
    color: appColors.neutral.white,
    borderRadius: 2,
    border: "1px solid ".concat(appColors.neutral.black),
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
};
